(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/prescript.js');

svs.challenge = svs.challenge || {};
svs.challenge.reducers = {};
svs.challenge.actions = {};
svs.challenge.constants = {};

svs.challenge.selectors = {};

svs.challenge.middleware = {};


 })(window);